import { render, staticRenderFns } from "./TaskList.vue?vue&type=template&id=6e11f12f&"
import script from "./TaskList.vue?vue&type=script&lang=js&"
export * from "./TaskList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gantt-elastic/gantt-elastic/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e11f12f')) {
      api.createRecord('6e11f12f', component.options)
    } else {
      api.reload('6e11f12f', component.options)
    }
    module.hot.accept("./TaskList.vue?vue&type=template&id=6e11f12f&", function () {
      api.rerender('6e11f12f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TaskList/TaskList.vue"
export default component.exports